import React, { Suspense, lazy, useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import { SuspenseSpinner } from "./shared";
import { getAccessToken } from "./services/auth/AuthToken";
import { ToastContainer } from "react-toastify";

const Sidebar = lazy(() => import("./shared/Sidebar"));
const Footer = lazy(() => import("./shared/Footer"));
const Navbar = lazy(() => import("./shared/Navbar"));
const SettingsPanel = lazy(() => import("./shared/SettingsPanel"));

function App({ userData }) {
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);
  const location = useLocation();

  const onRouteChanged = useCallback(() => {
    window.scrollTo(0, 0);

    const fullPageLayoutRoutes = [
      "/login",
      "/register",
      "/forgot-password",
      "/user-pages/login-1",
      "/user-pages/login-2",
      "/user-pages/register-1",
      "/user-pages/register-2",
      "/user-pages/lockscreen",
      "/error-pages/error-404",
      "/error-pages/error-500",
      "/reset-password/",
      "/microsoft/auth-callback/",
    ];

    const isFullPage = fullPageLayoutRoutes.includes(location.pathname);
    setIsFullPageLayout(isFullPage);

    const pageBodyWrapper = document.querySelector(".page-body-wrapper");
    if (isFullPage) {
      pageBodyWrapper?.classList.add("full-page-wrapper");
    } else {
      pageBodyWrapper?.classList.remove("full-page-wrapper");
    }
  }, [location.pathname]);

  useEffect(() => {
    onRouteChanged();
  }, [location, onRouteChanged]); // Run when location changes

  // Check if the user is logged in and has a valid access token
  const isNotLoggedIn = !userData?.loggedIn || !getAccessToken();  

  if (isFullPageLayout || isNotLoggedIn) {
    return (
      <Suspense fallback={<SuspenseSpinner />}>
        <div style={{
          height: "100vh",
        }}>
          <AppRoutes />
          <ToastContainer />
        </div>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<SuspenseSpinner />}>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <AppRoutes />
              <ToastContainer />
              <SettingsPanel />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </Suspense>
  );
}

const mapStateToProps = (state) => ({
  userData: state.userReducer
});

export default connect(mapStateToProps)(App);
